import styled from 'styled-components';

function findMaxColumnValue(arr, active) {
  const key = active === 'total' ? 'allCount' : 'level2Count';
  return arr.reduce((max, item) => {
    const value = typeof item[key] === 'number' ? item[key] : 0;
    return Math.max(max, value);
  }, 10);
}

export const HypoChart = ({ active, HypoglycemiaChartData }) => {
  const maxColumnValue = findMaxColumnValue(HypoglycemiaChartData, active);
  return (
    <StyledHypoChart>
      {HypoglycemiaChartData?.map((item) => {
        const value = active === 'total' ? item?.allCount : item?.level2Count;
        return (
          <StyledHypoChartColumn
            key={item.hours}
            columnValue={value}
            maxColumnValue={maxColumnValue}
          >
            <p className="chart-outside_value">{value}</p>
            {item?.type !== 'chart-label' ? (
              <div className="chart-column_container">
                <div className="chart-column_filled" />
                <p className="chart__inner_value">{value}</p>
              </div>
            ) : (
              <div className="chart-label">
                <p>Hypo Events</p>
              </div>
            )}
            <p className="hypo-hours">{item.hours}</p>
          </StyledHypoChartColumn>
        );
      })}
    </StyledHypoChart>
  );
};

const StyledHypoChart = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: row-reverse;
  gap: 5px;
  @media screen and (min-width: 1024px) {
    gap: 12px;
  }
`;

const StyledHypoChartColumn = styled.div`
  width: min-content;
  .chart-outside_value {
    height: 20px;
    visibility: ${({ columnValue, maxColumnValue }) =>
      columnValue >= maxColumnValue && columnValue !== 0
        ? 'visible'
        : 'hidden'};
  }
  .chart-column_container {
    display: flex;
    flex-direction: column-reverse;
    height: 168px;
    width: 32px;
    background-color: #f5f5f5;
    border-radius: 6px;
    padding: 6px;
  }
  .chart__inner_value {
    font-size: 14px;
    font-family: 'dana-bold';
    text-align: center;
    color: #753cbe;
    display: ${({ columnValue, maxColumnValue }) =>
      columnValue < maxColumnValue && columnValue !== 0 ? 'block' : 'none'};
  }
  .chart-label {
    margin: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column-reverse;
    width: 30px;
    height: 168px;
    p {
      transform: rotate(-90deg);
      font-size: 10px;
      font-family: 'dana-bold';
      letter-spacing: 1px;
      color: #707070;
      width: max-content;
    }
  }
  .hypo-hours {
    font-size: 10px;
    font-family: 'dana-bold';
    line-height: 16px;
    letter-spacing: 1px;
    text-align: center;
    padding-top: 7px;
    color: #707070;
  }
  .chart-column_filled {
    height: ${({ columnValue, maxColumnValue }) =>
      !isNaN((columnValue * 100) / maxColumnValue)
        ? (columnValue * 100) / maxColumnValue + '%'
        : '0'};
    background: linear-gradient(
      165deg,
      rgba(216, 29, 93, 1),
      rgba(216, 29, 93, 0.3)
    );
    width: 100%;
    border-radius: 6px;
  }
  @media screen and (min-width: 1024px) {
    .chart-label {
      height: 314px;
    }
    .chart-column_container {
      width: 64px;
      height: 314px;
      padding: 10px;
    }
    .hypo-hours,
    .chart-label p,
    .chart__inner_value,
    .chart-outside_value {
      font-size: 20px;
    }
    .hypo-hours,
    .chart-label p {
      color: #4e4e4e;
    }
    .hypo-hours {
      padding-top: 14px;
    }
  }
`;
